var _path, _path2, _circle, _path3, _path4, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcForbidden40 = function SvgIcForbidden40(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#737F89",
    d: "M18.75 29.969h2.5v5.875h-2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.75 29.969h2.5v2l-2.5 1v-3Z",
    opacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 16.594,
    r: 12.75,
    fill: "#fff",
    stroke: "#DB0909",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m8.36 8.813 12.977 21.718c-.44.041-.886.063-1.337.063-7.732 0-14-6.268-14-14 0-2.88.87-5.556 2.36-7.781Z",
    clipRule: "evenodd",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB0909",
    d: "m28.087 6.738 1.768 1.768-17.943 17.942-1.767-1.767z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.75,
    height: 2,
    x: 12.544,
    y: 35.406,
    fill: "#D6E1E8",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.75,
    height: 2,
    x: 4.794,
    y: 35.406,
    fill: "#D6E1E8",
    rx: 1
  })));
};
export { SvgIcForbidden40 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTguNzUiIHk9IjI5Ljk2ODgiIHdpZHRoPSIyLjUiIGhlaWdodD0iNS44NzUiIGZpbGw9IiM3MzdGODkiLz4KPHBhdGggb3BhY2l0eT0iMC4yIiBkPSJNMTguNzUgMjkuOTY4OEgyMS4yNVYzMS45Njg4TDE4Ljc1IDMyLjk2ODhWMjkuOTY4OFoiIGZpbGw9ImJsYWNrIi8+CjxjaXJjbGUgY3g9IjIwIiBjeT0iMTYuNTkzOCIgcj0iMTIuNzUiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNEQjA5MDkiIHN0cm9rZS13aWR0aD0iMi41Ii8+CjxwYXRoIG9wYWNpdHk9IjAuMiIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjM1OTQ4IDguODEzMDVMMjEuMzM3MyAzMC41MzA3QzIwLjg5NzIgMzAuNTcyNCAyMC40NTExIDMwLjU5MzggMjAgMzAuNTkzOEMxMi4yNjggMzAuNTkzOCA2IDI0LjMyNTcgNiAxNi41OTM4QzYgMTMuNzE0NSA2Ljg2OTE5IDExLjAzODIgOC4zNTk0OCA4LjgxMzA1WiIgZmlsbD0iYmxhY2siLz4KPHJlY3QgeD0iMjguMDg3NSIgeT0iNi43Mzg0NiIgd2lkdGg9IjIuNSIgaGVpZ2h0PSIyNS4zNzUiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDI4LjA4NzUgNi43Mzg0NikiIGZpbGw9IiNEQjA5MDkiLz4KPHJlY3QgeD0iMTIuNTQzNyIgeT0iMzUuNDA2MiIgd2lkdGg9IjE4Ljc1IiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSIjRDZFMUU4Ii8+CjxyZWN0IHg9IjQuNzkzNyIgeT0iMzUuNDA2MiIgd2lkdGg9IjUuNzUiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiNENkUxRTgiLz4KPC9zdmc+Cg==";